// Controlled number input hook — keeps local string state so partial typing
// (e.g. "1.") isn't eaten by parent conversion to Number on every keystroke.
// Ported verbatim from broker-team-analyzer-preview.html.

import { useEffect, useState } from 'react';

export function useNumberInput(value, onChange) {
  const [raw, setRaw] = useState(value == null ? '' : String(value));

  useEffect(() => {
    const parsed = parseFloat(raw);
    const same = Number.isNaN(parsed)
      ? value === 0 || value == null
      : parsed === value;
    if (!same) setRaw(value == null ? '' : String(value));
  }, [value]); // intentionally syncs on external value changes only

  const handleChange = (e) => {
    const s = e.target.value;
    if (s === '' || /^-?\d*\.?\d*$/.test(s)) {
      setRaw(s);
      if (s === '' || s === '-' || s === '.' || s === '-.') {
        onChange(0);
      } else {
        const n = parseFloat(s);
        if (!Number.isNaN(n)) onChange(n);
      }
    }
  };

  const handleBlur = () => {
    if (raw === '' || raw === '-' || raw === '.') {
      setRaw('0');
      onChange(0);
      return;
    }
    const n = parseFloat(raw);
    if (!Number.isNaN(n)) setRaw(String(n));
  };

  return { raw, handleChange, handleBlur };
}
